import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Michael Chen",
      company: "Elite Garden Designs",
      location: "Beverly Hills, CA",
      quote: "In just 6 months, we went from struggling to find $5K jobs to consistently booking $25K+ projects. Our revenue increased by 340% and we're now the go-to landscaper for luxury homes in our area.",
      projectIncrease: "340% revenue increase",
      avatar: "MC"
    },
    {
      name: "Sarah Williams",
      company: "Premium Landscapes Ltd",
      location: "Austin, TX", 
      quote: "The marketing strategy completely transformed our business. We now have a 3-month waitlist for projects over $15K. The quality of clients we attract has dramatically improved.",
      projectIncrease: "Average project: $18K",
      avatar: "SW"
    },
    {
      name: "David Rodriguez",
      company: "Artisan Outdoor Living",
      location: "Scottsdale, AZ",
      quote: "Before working with them, we were competing on price. Now we compete on value and craftsmanship. Our profit margins have doubled and we're booked solid with premium clients.",
      projectIncrease: "200% profit increase",
      avatar: "DR"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Success Stories from <span className="text-primary">VGP Clients</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See how we've helped premium service-based businesses transform their client base and dramatically 
            increase their project values.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-luxury hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-card/95 backdrop-blur-sm relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-accent to-amber-400"></div>
              <CardContent className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <Quote className="w-8 h-8 text-accent opacity-50" />
                  <div className="flex space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                    ))}
                  </div>
                </div>
                
                <p className="text-muted-foreground mb-6 leading-relaxed italic">
                  "{testimonial.quote}"
                </p>

                <div className="border-t border-border pt-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary to-primary-light rounded-full flex items-center justify-center">
                      <span className="text-primary-foreground font-semibold text-sm">
                        {testimonial.avatar}
                      </span>
                    </div>
                    <div>
                      <div className="font-semibold text-foreground">{testimonial.name}</div>
                      <div className="text-sm text-muted-foreground">{testimonial.company}</div>
                      <div className="text-xs text-muted-foreground">{testimonial.location}</div>
                    </div>
                  </div>
                  <div className="mt-4 p-3 bg-primary/10 rounded-lg border border-primary/20">
                    <div className="text-sm font-bold text-primary">{testimonial.projectIncrease}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;